import React from 'react';
import { Toolbar } from 'features/command-center';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import DataTable from 'UI/components/organisms/DataTable';
import { Endpoints } from 'UI/constants/endpoints';

import { EmailDetails } from './components';
import {
  COPIES,
  EMAIL_DETAILS_RENDERER,
  EMAILS_COLUMNS,
  ORDER_BY_OPTIONS,
  PAGE_KEY
} from './SendoutEmailsTabContent.constants';
import { formatResponse } from './SendoutEmailsTabContent.utils';

const extraRenderers = {
  [EMAIL_DETAILS_RENDERER]: value => (
    <EmailDetails subject={value?.subject} preview={value?.preview} />
  )
};

const getEmptyStateCopies = ({ hasSearchText }) => {
  if (hasSearchText) return COPIES.searchEmptyState;
  return COPIES.emptyState;
};

export const SendoutEmailsTabContent = ({ sendoutId }) => {
  const initialPreferences = getColumnPreferences(PAGE_KEY, 0, ORDER_BY_OPTIONS, EMAILS_COLUMNS, 0);

  const endpoint = Endpoints.SendoutEmails.replace(':id', sendoutId);

  const {
    columnPreferences,
    count,
    data,
    handleColumnDisplayChange,
    handleColumnOrderChange,
    handleColumnSortChange,
    handleFiltersToggle,
    handleKeywordChange,
    handlePageChange,
    handlePerPageChange,
    listState
  } = useDatatable({
    apiVersion: 2,
    columnsDefinitions: EMAILS_COLUMNS,
    endpoint,
    formatResponse,
    initialPreferences,
    key: PAGE_KEY,
    orderByOptions: ORDER_BY_OPTIONS,
    shouldScrollOnNavigate: true,
    shouldUseSavedPagination: false
  });

  const { isLoading, showWholeSkeleton, page, perPage, keyword } = listState;
  const { columns, columnOrder, orderBy, direction } = columnPreferences;

  const finalColumns = getColumnsToRender(columns, extraRenderers);
  const hasSearchText = Boolean(keyword && keyword.trim());
  const emptyStateCopies = getEmptyStateCopies({ hasSearchText });

  return (
    <DataTable
      columnOrder={columnOrder?.length ? columnOrder : undefined}
      columns={finalColumns}
      components={{ TableToolbar: Toolbar }}
      count={count ?? 0}
      data={data}
      draggableColumns={{ enabled: true }}
      elevation={0}
      filter={false}
      loading={showWholeSkeleton}
      onColumnDisplayClick={handleColumnDisplayChange}
      onColumnOrderChange={handleColumnOrderChange}
      onColumnSortChange={handleColumnSortChange}
      onPageClick={handlePageChange}
      onPerPageClick={handlePerPageChange}
      onSearchTextChange={handleKeywordChange}
      onToggleFilters={handleFiltersToggle}
      page={page}
      refreshing={isLoading}
      rowsPerPage={perPage}
      searchText={keyword}
      selectToolbarPlacement="none"
      selectableRows="none"
      sortOrder={{ name: orderBy, direction }}
      subtitle={emptyStateCopies.subtitle}
      title={emptyStateCopies.title}
    />
  );
};
